<template>
	<div id="companyhistory"></div>
</template>

<script>
	export default {
		props: {
			info: {
				type: Array,
				default () {
					return [];
				}
			},
			type: {
				type: Number,
				default: 0
			}
		},
		watch: {
			info: {
				handler(val) {
					if (val && val.length) {
						this.options.xAxis.data = val.map(item => item.StockMonth);
						this.options.title[2].text = `时间：${this.type?'季度':'年月'}`;
						this.options.series[0].data = val.map(item => this.fixedVal(item.StandardSum))
						this.options.series[1].data = val.map(item => item.StockDayCount)
						//this.options.dataZoom[0].start = 12 / val.length > 1 ? 0 : (1 - (12 / val.length)) * 100;
						setTimeout(() => {
							this.myChart.clear();
							this.myChart.setOption(this.options);
						}, 200)
					} else {
						this.options.series[0].data = [];
						this.options.series[1].data = [];
						if (this.myChart) {
							this.myChart.setOption(this.options);
							this.myChart.clear();
						}
					}
				},
				deep: true,
				immediate: true
			}
		},
		data() {
			return {
				myChart: null,
				options: {
					title: [{
						text: '金额：万元',
						left: '4%',
						top: '2%',
						textStyle: {
							color: '#1D2129',
							fontSize: 12,
							fontWeight: 'normal'
						}
					}, {
						text: '天数',
						right: '4%',
						top: '2%',
						textStyle: {
							color: '#1D2129',
							fontSize: 12,
							fontWeight: 'normal'
						}
					}, {
						text: '时间：年月',
						right: '4%',
						bottom: '14%',
						textStyle: {
							color: '#1D2129',
							fontSize: 12,
							fontWeight: 'normal'
						}
					}],
					tooltip: {
						trigger: 'axis',
						confine: true,
						hideDelay: 3000
					},
					dataZoom: [{
						type: 'slider',
						start: 65,
						end: 100,
						moveHandleSize: 10,
						fillerColor: 'transparent',
						brushSelect: false,
					}],
					grid: {
						left: '8%',
						right: '8%',
						bottom: '20%'
					},
					toolbox: {
						show: true,
						top: 8,
						right: 140,
						feature: {
							saveAsImage: {
								icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAA2ZJREFUWEfFl09oE0EUh783m4oHBRGFHnqImMTqSUFBUVAPgj0IHhS8iIoetKS1gqIHxYBeRMXWhFKxoAfBgwcLIgge9KAgWLAH0ZpY7EGxoIJgD7HZ3ZHdTbabv91ognNakpn3++bNe2/eCP95SJV+9PBiFi1dg82yptm09YWp4Y/NrCsHSCQvAudAFjdjJDDXRBubyA1OuL+t612CabxBk6fwaxPTd/OVducBEskUiAPwL2MWy9rge6H7eBS745NrUBVWMTkyXRvAJVXf3J1rHiP6NMqsol2QTKnvvBue9eeFBliT3IiW195CvZZsZnJBsTATQgPEkjtQ8qyRq8Lozc9JRSBl8l8A4snLiJzF5gyRwlhZDJgde1HcQOsT5DIjDrAXhK30QKJ/FPRR7zQZRBio+obrZNOn2wPgpd4TYGudY3tJxNpdCtbWe2A+/2tBlIm3xwOlbVd7whM3VRe2zPIx/bm9ACVPFIwRRJtE7CS/6cQw3gM/yaZXth+gMgiCwZ5Nu8ffnhioVzT+GsA5z4JxFmEzWp7TYQ6VldywVeqvAKK9nSwyHgKbAzrjzFl7mB6eqdZORUj8uAH6mPefGiS7/IJbGZsGiPV1oXgKdBeFnNTaXfz+jCU9TN18W1aC4z/uI+yrABtHFfZjRqJ+yV8wBhLJbnDvh07ARPQRPmTukeg/APoO4PQMs1iyn6mbTyAVISgu3MLWeUROFivhT5SMorVbAWkIYKsucN2+whVBHySbGfN3lTi5DewHPhwygNY7/J1rPUQu45XgRHIviANc3mHVBXAuCpGrwBJPXPWQHXpRddare2MYxqPA8XhTguKlRd0DUWzLAd7o26kLMK80A3pnw94gOrCMDmsMYbsfFxFrbe0McYLz+wiId1EtADCJZe0J12C6hkdBDhVdMMGc3VMzQ0JlATLBnFnbQKN8j/edR7jkewK9q8p7oQAsKx5u5zVoghmiuUwufaFsViiAOt1r2GKH118ewuZK6cbz19YFiPeuR4w3XhRbG8gNe319q0esbx8KJxsqgtB7DX0t5uorHPdpJwVbOESvQOQaEAVekU1vcawHHib9x0DfbqFkPVMmqJ2l2lLxNOs/gNaXEGJtAhkHdSpY2Kofp46yc/3atlOGWzfy+ZnGb8PWSTVl6Q8eGbAwgbTYagAAAABJRU5ErkJggg==',
								name: 'L3公司销量趋势图',
								show: true
							}
						}
					},
					legend: {
						data: ['金额', '天数'],
						itemWidth: 35,
						itemHeight: 18,
						left: '10%',
						top: '1%'
					},
					xAxis: {
						type: 'category',
						data: [],
						axisPointer: {
							type: 'shadow'
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							rotate: 30,
							fontSize: 12,
							color: '#1D2129'
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#E5E6EB',
								type: [5, 10]
							}
						},
						splitLine: {
							show: false
						},
						splitArea: {
							show: false
						}
					},
					yAxis: [{
							type: 'value',
							axisLabel: {
								show: true,
								//rotate: 45,
								fontSize: 12,
								color: '#01080F',
							},
							axisLine: {
								show: true,
								lineStyle: {
									color: '#E5E6EB',
									type: [5, 10]
								}
							},
							splitLine: {
								show: true,
								lineStyle: {
									color: '#E5E6EB',
									type: [5, 10]
								}
							}
						},
						{
							type: 'value',
							axisLabel: {
								show: true,
								//rotate: 45,
								fontSize: 12,
								color: '#01080F'
							},
							axisLine: {
								show: true,
								lineStyle: {
									color: '#E5E6EB',
									type: [5, 10]
								}
							},
							splitLine: {
								show: false
							}
						}
					],
					series: [{
							name: '金额',
							type: 'bar',
							itemStyle: {
								color: '#00266D',
								//borderRadius: [4, 4, 0, 0]
							},
							barMaxWidth: 36,
							tooltip: {
								valueFormatter: function(value) {
									return value + ''; //万
								}
							},
							data: []
						},
						{
							name: '天数',
							type: 'line',
							// lineStyle: {
							// 	color: 'transparent'
							// },
							//symbol: 'triangle',
							//symbolSize: 10,
							yAxisIndex: 1,
							itemStyle: {
								color: '#FF0000'
							},
							tooltip: {
								valueFormatter: function(value) {
									return value + ''; //天
								}
							},
							data: []
						}
					]
				}
			}
		},
		mounted() {
			this.init();
		},
		methods: {
			init() {
				let _this = this;
				this.myChart = this.$MyEcharts.init(document.getElementById('companyhistory'));
				this.myChart.clear();
				this.myChart.setOption(this.options);
				window.addEventListener("resize", function() {
					_this.myChart.resize();
				});
			},
			fixedVal(val, num = 1) {
				return (val / 10000).toFixed(num);
			}
		}
	}
</script>

<style lang="less">
	#companyhistory {
		height: 520px;
		//background: #ffffff;
		//margin-top: 16px;
		padding: 16px;
	}
</style>